export const getNumRect = (rect) => {
    return {
        x: conversionPX(rect.start.x, window === null || window === void 0 ? void 0 : window.innerWidth),
        y: conversionPX(rect.start.y, window === null || window === void 0 ? void 0 : window.innerHeight),
        width: conversionPX(rect.width, window === null || window === void 0 ? void 0 : window.innerWidth),
        height: conversionPX(rect.height, window === null || window === void 0 ? void 0 : window.innerHeight)
    };
};
const conversionPX = (str, base) => {
    if (str.endsWith('px')) {
        return Number(str.replace('px', ''));
    }
    if (str.endsWith('%')) {
        if (!base)
            return 500;
        return base * Number(str.replace('%', '')) / 100;
    }
    return 0;
};
export const getSize = (winRect, width, height) => {
    const ratio = (winRect.right - winRect.left) / (winRect.bottom - winRect.top);
    // windowの方がブラウザと比べて横に長い場合
    if (ratio > (width / height)) {
        return {
            width: width,
            height: width / ratio,
            expr: (winRect.right - winRect.left) / width
        };
    }
    return {
        width: ratio * height,
        height: height,
        expr: (winRect.bottom - winRect.top) / height
    };
};
